import { IconPropsType } from '..';

export const FullScreenIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="general=default, betting=default, statuses=default, arrows=default, toggleables=fullscreen, signs=default, menus=default, casino=default">
      <path
        id="Vector (Stroke)"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 2.68571C2 2.307 2.307 2 2.68571 2H7.9102C8.28891 2 8.5 2.62129 8.5 3C8.5 3.37871 8.28891 4 7.9102 4H4V7.9102C4 8.28891 3.37871 8.5 3 8.5C2.62129 8.5 2 8.28891 2 7.9102V2.68571ZM11.5 3C11.5 2.62129 11.7111 2 12.0898 2H17.3143C17.693 2 18 2.307 18 2.68571V7.9102C18 8.28891 17.3787 8.5 17 8.5C16.6213 8.5 16 8.28891 16 7.9102V4H12.0898C11.7111 4 11.5 3.37871 11.5 3ZM3 11.5C3.37871 11.5 4 11.7111 4 12.0898V16H7.9102C8.28891 16 8.5 16.6213 8.5 17C8.5 17.3787 8.28891 18 7.9102 18H2.68571C2.307 18 2 17.693 2 17.3143V12.0898C2 11.7111 2.62129 11.5 3 11.5ZM17 11.5C17.3787 11.5 18 11.7111 18 12.0898V17.3143C18 17.693 17.693 18 17.3143 18H12.0898C11.7111 18 11.5 17.3787 11.5 17C11.5 16.6213 11.7111 16 12.0898 16H16V12.0898C16 11.7111 16.6213 11.5 17 11.5Z"
      />
    </g>
  </svg>
);
